import { Divider, ListItemIcon, Menu, MenuItem, MenuList } from "@mui/material";
import React from "react";

import { MdRemoveCircleOutline } from "react-icons/md";
import { TbEdit } from "react-icons/tb";
import { BsImage } from "react-icons/bs";

const ProductGroupMenu = ({
  context,
  group,
  anchorEl,
  handleClose,
  contextMenu,
  setOpenGroupUpdate,
  setOpenGroupImageUpdate,
  deleteGroup,
}) => {
  return (
    <Menu
      {...(context
        ? {
            open: contextMenu !== null,
            anchorReference: "anchorPosition",
            anchorPosition:
              contextMenu !== null
                ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                : undefined,
          }
        : {
            anchorEl: anchorEl,
            open: anchorEl !== null,
          })}
      onClose={handleClose}
      onClick={handleClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <MenuList dense={false}>
        <MenuItem
          onClick={() => {
            setOpenGroupUpdate(true);
          }}
        >
          <ListItemIcon>
            <TbEdit />
          </ListItemIcon>
          Edit group
        </MenuItem>
        <MenuItem
          onClick={() => {
            setOpenGroupImageUpdate(true)
            
          }}
        >
          <ListItemIcon>
            <BsImage />
          </ListItemIcon>
          Change group icon
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            deleteGroup(group.id);
          }}
        >
          <ListItemIcon>
            <MdRemoveCircleOutline />
          </ListItemIcon>
          Remove item
        </MenuItem>

        {/* <MenuItem onClick={() => {}}>
          <ListItemIcon>
            <MdCloudDownload />
          </ListItemIcon>
          Download QR image
        </MenuItem> */}
      </MenuList>
    </Menu>
  );
};

export default ProductGroupMenu;
